// create function
import { createDialog } from '@/assets/scripts/dialog'

import audioDialogVue from './media/audio.dialog'
import imageDialogVue from './media/image.dialog'
// order
import orderDialogVue from './order/order.dialog'
// project
import upgradeProjectDialogVue from './project/upgrade.dialog'
// category edit
import editCategoryDialogVue from './category/edit.dialog'

const install = (Vue, opts = {}) => {
  Vue.prototype.$mediaAudio = createDialog(audioDialogVue)
  Vue.prototype.$mediaImage = createDialog(imageDialogVue)
  Vue.prototype.$order = createDialog(orderDialogVue)
  Vue.prototype.$upgradeProject = createDialog(upgradeProjectDialogVue)
  Vue.prototype.$editCategory = createDialog(editCategoryDialogVue)
}

module.exports = {
  install
}



// WEBPACK FOOTER //
// ./src/plugins/dialogs.js